/** @deprecated Legacy test keys removed — master testing key (Rule 6) is the sole bypass. */

export function isMasterSandboxUser(user: { masterTestingOverride?: boolean; testOverride?: boolean } | null) {
  return Boolean(user?.masterTestingOverride || user?.testOverride);
}

export function getSandboxWelcomeMessage(user: { role?: string; masterTestingOverride?: boolean } | null) {
  if (!isMasterSandboxUser(user)) return null;
  if (user?.role === 'ELT') {
    return 'Welcome to your Corporate Briefing Room. Your organisation-linked mentor workspace is ready — Org Shared Pack and corporate briefing tools are active for this session.';
  }
  return 'Welcome to the Living Room. Your private mentee briefing workspace is ready — begin your Socratic session whenever you are prepared.';
}
